import { useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { WEBBACK_V2_API } from "@constants"
import { useToast, useUserApp } from "@hooks"
import { digitalShelfReportFormIsOpen, digitalShelfSubmittedFilters } from "../@signals"


export default function useDigitalShelfReportForm(dataRow={}) {
    const { showToast } = useToast()
    const { userEmail, userCustomer } = useUserApp()

    const nameReport = useSignal('')
    const frequency = useSignal(null)
    const emailsReport = useSignal([userEmail])

    const resetFormData = () => {
        nameReport.value = ''
        frequency.value = null
        emailsReport.value = [userEmail]
    }

    const handleOpenForm = () => {
        digitalShelfReportFormIsOpen.value = true
    }

    const handleSendToBack = () => {
        let apiUrl =`${WEBBACK_V2_API}/reports/create`

        if (frequency.value === 'now') {
            apiUrl = `${WEBBACK_V2_API}/reports/execute-now`
        }

        const payload = {
            nameReport: nameReport.value,
            frequency: frequency.value,
            emailsReport: emailsReport.value.join(","),
            reportType: 'digitalShelf',
            filters: {
                country: digitalShelfSubmittedFilters.value.country, retailer: digitalShelfSubmittedFilters.value.retailer,
                brand: digitalShelfSubmittedFilters.value.brand, skuGroup: digitalShelfSubmittedFilters.value.skuGroup,
                sku: digitalShelfSubmittedFilters.value.sku, splitKpi: digitalShelfSubmittedFilters.value.splitKpi,
                id_customer: userCustomer
            }
        }

        showToast.promise(postSubmit(apiUrl, payload), {
            error: 'Error: Please try again later.',
            success: `Report successfully created.`,
        })
    }

    return {
        handleOpenForm,
        handleSendToBack,
        resetFormData,
        nameReport: nameReport,
        frequency: frequency,
        emailsReport: emailsReport
    }
}